var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResendMailDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.096,
    viewBox: "0 0 18 17.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_649",
    "data-name": "Union 649",
    d: "M12.7,16.9a.687.687,0,0,1,0-.973l2.951-2.951H8.688a.688.688,0,0,1,0-1.375h6.965L12.7,8.645a.687.687,0,0,1,.972-.972l4.11,4.11a.667.667,0,0,1,.1.122h0a.051.051,0,0,0,.007.012l0,.005.005.007,0,.009,0,0,.006.011v0a.1.1,0,0,1,.007.014.683.683,0,0,1-.007.639v0l-.006.011,0,.005a.036.036,0,0,0,0,.008l-.005.008,0,0-.007.012,0,0a.651.651,0,0,1-.1.121L13.674,16.9a.689.689,0,0,1-.972,0ZM6.5,12.972H2.431A2.433,2.433,0,0,1,0,10.542V2.43A2.436,2.436,0,0,1,2.431,0H15.57A2.433,2.433,0,0,1,18,2.43V9.737L16.724,8.461v-6.5L10.507,6.863a2.429,2.429,0,0,1-3.013,0L1.277,1.957v8.585a1.154,1.154,0,0,0,1.154,1.152H6.477a2.291,2.291,0,0,0,.028,1.277h0ZM8.286,5.857a1.155,1.155,0,0,0,1.429,0l5.8-4.58H2.484Z",
    fill: "#f8f8f8",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendMailDark);
export default __webpack_public_path__ + "static/media/resend_mail_dark.c14f8e36f39a6e09fa881b7670bc0191.svg";
export { ForwardRef as ReactComponent };